module.exports = __webpack_public_path__ + "media/images/entidades_organizadoras/fpul-cb19363c5c05a44267210ed6efe5d564.svg";